export default "__VITE_ASSET__C6hx3Qg1__"